import { render, staticRenderFns } from "./projectOrganization.vue?vue&type=template&id=0bccd3ef&scoped=true&"
import script from "./projectOrganization.vue?vue&type=script&lang=js&"
export * from "./projectOrganization.vue?vue&type=script&lang=js&"
import style0 from "./projectOrganization.vue?vue&type=style&index=0&id=0bccd3ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccd3ef",
  null
  
)

export default component.exports